import { Pipe, PipeTransform } from '@angular/core';
import {PlanGroupRiderModel} from '../../models/select-plans/product-rider.model';
@Pipe({
  name: 'filterRider'
})
export class DisplaySearchRiderPipe implements PipeTransform {

  transform(riders: Array<PlanGroupRiderModel>, textSearch: string): any {
    // I am unsure what id is here. did you mean title?
    return textSearch
      ? riders.filter(item => (item.planGroupCode.toLocaleUpperCase().indexOf(textSearch.toLocaleUpperCase()) !== -1) ||
        (item.planGroupName.toLocaleUpperCase().indexOf(textSearch.toLocaleUpperCase()) !== -1))
      : riders;
  }
}
